import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useFormContext } from "../../context/Context";
import { IoPersonSharp } from "react-icons/io5";
import { RiLockPasswordFill } from "react-icons/ri";
import { BiSolidHide, BiSolidShow } from "react-icons/bi";
import axios from "axios";
import api from "../../services/api";
import axiosPublic from "../../services/axios/axiosPublic";
import { Button, Modal, Form } from "react-bootstrap";
import Captcha from "../../components/common/Captcha";
import { toast, ToastContainer } from "react-toastify";
import {
  browserName,
  osName,
  isMobile,
  isTablet,
  deviceType,
} from "react-device-detect";
import { useDispatch, useSelector } from "react-redux";
import { savePermissions } from "../../redux/formActions";
import { fetchverifyTokenDetails } from "../../redux/slice/verifyTokenSlice";
import { openModal } from "../../redux/slice/managePasswordSlice";
import { useForm } from "react-hook-form";
import { setActiveMenu } from "../../redux/slice/activeMenuSlice";
import { fetchSearchData } from "../../redux/slice/searchDataSlice";

export default function LoginForm() {

  const { isPolicyAccepted, isJoiningFormCompleted, isExistingEmp } =
      useSelector((state) => state?.persistedReducer?.forms?.savedPermissions) ||
      {};
  const searchDataList = useSelector(
    (state) => state.SearchData.SearchDataList,
  );
  const parseTimeFromMessage = (msg) => {
    const match = msg.match(/(\d+)\s*minutes?\s*(\d+)\s*seconds?/i);
    if (!match) return null;

    const minutes = parseInt(match[1], 10);
    const seconds = parseInt(match[2], 10);
    return minutes * 60 + seconds;
  };

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const tokendata = useSelector((state) => state.TokenDetails.TokenDetails);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
    clearErrors
  } = useForm();
  const { serverError, setServerError } = useFormContext();

  const [password, setPassword] = useState("");
  const [passwordShow, setPasswordShow] = useState(false);
  const [isLockedOut, setIsLockedOut] = useState(false);
  const [lockoutTime, setLockoutTime] = useState(null);
  const [lockoutError, setLockoutError] = useState("");
  const [, setLoginAttempts] = useState(() => {
    return Number.parseInt(localStorage.getItem("loginAttempts") || "0", 10);
  });
  const [, setCountdown] = useState(0);

  const [otpError, setOtpError] = useState("");
  const [, setIsLoading] = useState(true);

  const [showOtpPopup, setShowOtpPopup] = useState(false);
  const [otp, setOtp] = useState("");
  const [userEmail, setUserEmail] = useState("");

  const [resendCountdown, setResendCountdown] = useState(45);
  const [canResend, setCanResend] = useState(false);
  const [showCaptcha, setShowCaptcha] = useState(() => {
    return localStorage.getItem("showCaptcha") === "true";
  });

  const [isCaptchaValid, setIsCaptchaValid] = useState(false);
  const { loginEmail, loginPassword } = watch();

  const isLoginDisabled =
    !loginEmail ||
    !loginPassword ||
    isLockedOut ||
    (showCaptcha && !isCaptchaValid);

  const emailRegex = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token && !tokendata) {
      dispatch(fetchverifyTokenDetails(token));
    }
    if (token && tokendata&&searchDataList?.result?.length>0) {
        if(!isJoiningFormCompleted){
          dispatch(setActiveMenu({ menu: "myjoiningdetails", subMenu: "summary" }));
          navigate("/admin/my-details", { replace: true });
        }
        else if(isExistingEmp){
           dispatch(setActiveMenu({ menu: 'uploaddocuments', subMenu: "summary" }));
           navigate("/admin/my-details", { replace: true });
        }
        else if(!isPolicyAccepted){
           dispatch(setActiveMenu({ menu: 'policies', subMenu: "summary" }));
           navigate("/admin/my-details", { replace: true });
        }else{
          navigate("/admin/dashboard", { replace: true });
        }
      
      console.log('token======', token, 'tokendata==========', tokendata);
    }

    const timer = setTimeout(() => setIsLoading(false), 1500);
    return () => clearTimeout(timer);
  }, [tokendata,searchDataList, navigate, dispatch]);

  useEffect(() => {
    const savedLockTime = localStorage.getItem("lockoutTime");
    const savedMessage = localStorage.getItem("lockoutMessage");
    const savedCaptcha = localStorage.getItem("showCaptcha");

    if (savedLockTime && Date.now() < Number(savedLockTime)) {
      setLockoutTime(Number(savedLockTime));
      setIsLockedOut(true);

      if (savedMessage) {
        setLockoutError(savedMessage);
      }

      setShowCaptcha(true);
    } else {
      localStorage.removeItem("lockoutTime");
      localStorage.removeItem("lockoutMessage");
    }

    if (savedCaptcha === "true") {
      setShowCaptcha(true);
    }
  }, []);
  useEffect(()=>{
    if(tokendata!==""){
    dispatch(fetchSearchData({type: "employee",keyword: tokendata?.trim(),page: 0,}))
    }
  },[tokendata])

  const handleInputChange = (fieldName) => {
    setServerError("");
    clearErrors(fieldName);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    setServerError("");
    clearErrors("loginPassword");
    setValue("loginPassword", e.target.value);
  };

  const handlePasswordVisibility = () => setPasswordShow(!passwordShow);

  const handleFormSubmit = async (data) => {
    if (isLockedOut) return;

    if (showCaptcha && !isCaptchaValid) {
      setServerError("Please complete the captcha");
      return;
    }

    const payload = { username: data.loginEmail, password: data.loginPassword };
    setIsLoading(true);
    try {
      const response = await axiosPublic.post(api.login, payload);
      if (response?.data?.success === true) {
        setLoginAttempts(0);
        setShowCaptcha(false);
        localStorage.removeItem("loginAttempts");
        localStorage.removeItem("showCaptcha");

        setIsLockedOut(false);
        setLockoutError("");
        localStorage.removeItem("lockoutTime");

        setUserEmail(data.loginEmail);
        setShowOtpPopup(true);
        setCanResend(false);
        setResendCountdown(45);
      } else {
        if (response?.data?.reason?.includes("Account locked")) {
          if (!lockoutTime) {
            const lockTime = Date.now() + 30 * 60 * 1000;
            setLockoutTime(lockTime);
            setIsLockedOut(true);
            localStorage.setItem("lockoutTime", lockTime);
          }
        }
        handleFailedAttempt(response?.data?.reason || "Invalid credentials");
      }
    } catch (err) {
      handleFailedAttempt("Unable to connect to server");
      setServerError(err?.message || "Unable to connect to server");
    } finally {
      setIsLoading(false);
    }
  };

  const handleFailedAttempt = (msg) => {
    setServerError(msg);

    setLoginAttempts((prev) => {
      const newAttempts = prev + 1;

      localStorage.setItem("loginAttempts", newAttempts.toString());
      if (newAttempts >= 4) {
        setShowCaptcha(true);
        localStorage.setItem("showCaptcha", "true");
      }

      if (newAttempts >= 4 && !isLockedOut) {
        const lockTime = Date.now() + 15 * 60 * 1000;

        const msg = "Account locked. Please try again after 15 minutes 0 seconds.";
        setLockoutTime(lockTime);
        setIsLockedOut(true);
        setLockoutError(msg);

        localStorage.setItem("lockoutTime", lockTime);
        localStorage.setItem("lockoutMessage", msg);

        setShowCaptcha(true);
        localStorage.setItem("showCaptcha", "true");
      }

      return newAttempts;
    });
  };

  useEffect(() => {
    if (!lockoutTime) return;

    const interval = setInterval(() => {
      const timeLeft = Math.max(0, Math.floor((lockoutTime - Date.now()) / 1000));
      const minutes = Math.floor(timeLeft / 60);
      const seconds = timeLeft % 60;

      if (timeLeft > 0) {
        setLockoutError(`Account locked. Please try again after ${minutes} minutes ${seconds} seconds.`);
      } else {
        setLockoutError("");
        setIsLockedOut(false);
        setLockoutTime(null);

        localStorage.removeItem("lockoutTime");
        localStorage.removeItem("lockoutMessage");
        localStorage.removeItem("loginAttempts");
        localStorage.removeItem("showCaptcha");
        clearInterval(interval);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [lockoutTime]);

  const handleOtpFormSubmit = (e) => {
    e.preventDefault(); 
    handleVerifyOtp();
  };

  const handleVerifyOtp = async () => {
    if (otp.length !== 6) return;
    setIsLoading(true);
    try {
      const ipResponse = await axios.get("https://api.ipify.org?format=json");
      const ipAddress = ipResponse.data.ip || "0.0.0.0";
      let deviceCategory = "Desktop";
      if (isMobile) {
        deviceCategory = "Mobile";
      } else if (isTablet) {
        deviceCategory = "Tablet";
      }

      const deviceInfo = `${deviceCategory} - ${osName} - ${deviceType} - ${browserName}`;
      const payload = {
        email: userEmail,
        otp,
        deviceInfo,
        ipAddress,
      };
      const response = await axiosPublic.post(api.verifyOtp, payload);
      if (response?.data?.success === true) {
        const userData = response.data.data;
        const { token,
          roleName,
          fullName,
          email,
          permissions,
          userId,
          isApprover,
          isPasswordUpdated,isPolicyAccepted,isJoiningFormCompleted,isExistingEmp } = userData;

        const storageMap = {
          token: token,
          role: roleName,
          name: fullName || "",
          email,
          isApprover,
          permissions: JSON.stringify(permissions)
        };

        Object.entries(storageMap).forEach(([key, value]) => {
          if (value !== undefined) localStorage.setItem(key, value);
        });
        const flatMapPermission = (permissions || []).flatMap((p) => {
          const keys = [];
          if (p.canView)
            keys.push({ id: `${p.id}-view`, name: `${p.name}-view` });
          if (p.canManage)
            keys.push({ id: `${p.id}-manage`, name: `${p.name}-manage` });
          if (p.canDelete)
            keys.push({ id: `${p.id}-delete`, name: `${p.name}-delete` });
          return keys;
        });
        const PermissionsList = {
          permissions: flatMapPermission,
          userId,
          roleName,
          email,
          isApprover,
          isPasswordUpdated:(email==="gaurav.katiyar@moptra.com"||email==="saurabh.katiyar@moptra.com")?true:isPasswordUpdated,
          isPolicyAccepted:(email==="gaurav.katiyar@moptra.com"||email==="saurabh.katiyar@moptra.com")?true:isPolicyAccepted,
          isJoiningFormCompleted:(email==="gaurav.katiyar@moptra.com"||email==="saurabh.katiyar@moptra.com")?true:isJoiningFormCompleted,
          isExistingEmp:(email==="gaurav.katiyar@moptra.com"||email==="saurabh.katiyar@moptra.com")?false:isExistingEmp,
        };
        dispatch(savePermissions(PermissionsList));
        setShowOtpPopup(false);
        if(email==="gaurav.katiyar@moptra.com"||email==="saurabh.katiyar@moptra.com"){
          const lastPath = sessionStorage.getItem("last Path");
          console.log('lastPathlogin',lastPath)
            sessionStorage.removeItem("last path");
            navigate(lastPath || "/admin/dashboard", { replace: true });
        }
        else if (isPasswordUpdated === false && roleName !== "SUPER_ADMIN") {
          dispatch(openModal({ isForNewUser: true }));
        }
        else if(!isJoiningFormCompleted){
          dispatch(setActiveMenu({ menu: "myjoiningdetails", subMenu: "summary" }));
          navigate("/admin/my-details", { replace: true });
        }
        else if(!isPolicyAccepted){
           dispatch(setActiveMenu({ menu: 'policies', subMenu: "summary" }));
           navigate("/admin/my-details", { replace: true });
        }
        else {
          const lastPath = sessionStorage.getItem("last Path");
          console.log('lastPathlogin',lastPath)
          // if (lastPath) {
            sessionStorage.removeItem("last path");
            navigate(lastPath || "/admin/dashboard", { replace: true });
          // }
        }
      } else {
        console.log("else bl run:");
        toast.error(response?.data?.reason || "Invalid OTP", {
          className: "toast-error-custom",
        });
      }
      setOtp("");
    } catch (err) {
      console.log("catch blk run:", err);
      toast.error(err?.data?.reason || "OTP verification failed", {
        className: "toast-error-custom",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleResendOtp = async () => {
    if (!canResend) return;
    setResendCountdown(45);
    setCanResend(false);
    setIsLoading(true);

    try {
      const payload = { username: userEmail, password };
      const response = await axiosPublic.post(api.login, payload);

      if (response?.data?.success === true) {
        toast.success(response?.data?.reason || "OTP has been re-send", { className: "toast-success-custom", });
      } else {
        toast.error(response?.data?.reason || "Failed to re-send OTP", { className: "toast-error-custom", });
      }
    } catch (err) {
      toast.error(err?.data?.reason || "Failed to re-send OTP", { className: "toast-error-custom", });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (resendCountdown > 0) {
      const interval = setInterval(() => {
        setResendCountdown((prev) => {
          if (prev <= 1) {
            setCanResend(true);
            clearInterval(interval);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [resendCountdown]);

  let errorMessage = null;
  if (lockoutError) {
    errorMessage = <p className="invalidLoginErrorMessage">{lockoutError}</p>;
  } else if (serverError) {
    errorMessage = <div className="invalidLoginErrorMessage">{serverError}</div>;
  }

  return (
    <div className="container-fluid" id="container-fluid-login">
      <div className="main-logo">
        <div className="logo-image">
          <img src={require("assets/img/company_logo.png")} alt="Logo" />
        </div>
      </div>

      <div className="login-container" id="res-login-container">
        <div className="login-row">
          <div className="col-lg-12 col-md-10 col-sm-8 col-xs-12 left login-row-inner">
            <div className="login-form">
              <div className="title">
                <p className="welcome">LOGIN</p>
              </div>
              <div className="form" id="form">
                <form onSubmit={handleSubmit(handleFormSubmit)}>
                  <div className="form-detail">
                    <div className={`input-text ${errors.loginEmail ? "error" : ""}`} >
                      <p className="logo-txt">Email ID</p>
                      <div className="input-icons">
                        <IoPersonSharp className="icon" />
                        <input
                          id="login-input-field-email"
                          className="login-input-field"
                          type="email"
                          placeholder="Enter Email ID"
                          {...register("loginEmail", {
                            pattern: {
                              value: emailRegex,
                              message: "Please enter a valid email address",
                            },
                          })}
                          onChange={(e) => {
                            handleInputChange("loginEmail");
                            setValue("loginEmail", e.target.value);
                          }}
                        />
                        {errors.loginEmail && (
                          <p className="error-message">
                            {errors.loginEmail.message}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="input-text">
                      <p className="logo-txt">Password</p>
                      <div className="input-icons">
                        <RiLockPasswordFill className="icon" />
                        <input
                          id="login-input-field-password"
                          className="login-input-field"
                          type={passwordShow ? "text" : "password"}
                          placeholder="Enter Password"
                          {...register("loginPassword")}
                          value={password}
                          onChange={handlePasswordChange}
                        />
                        {password.length > 0 && (
                          <button
                            className="visibility-password"
                            type="button"
                            onClick={handlePasswordVisibility}
                          >
                            {passwordShow ? <BiSolidHide /> : <BiSolidShow />}
                          </button>
                        )}
                      </div>
                    </div>
                    <Link className="forgot-password" to={"/forgot-password"}>
                      Forgot Password?
                    </Link>
                    {showCaptcha && (
                      <Captcha
                        onChange={(valid) => setIsCaptchaValid(valid)} // real-time validation
                      />
                    )}
                    <div>
                      <button className="login" type="submit" disabled={isLoginDisabled}>
                        Login
                      </button>
                    </div>
                    <br />
                  </div>
                </form>
                {errorMessage}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* OTP Modal */}
      <Modal
        show={showOtpPopup}
        onHide={() => { }}
        backdrop="static"
        keyboard={false}
        centered
        className="otp-modal"
      >
        <Modal.Header>
          <Modal.Title>Enter OTP to proceed</Modal.Title>
        </Modal.Header>
        <Modal.Body className="otp-modal-body">
          <p className="modal-description">
            For enhanced security of your account, we have sent a One-Time
            Password (OTP) to your email ID{" "}
            <strong style={{ color: "#6a1b9a" }}>{userEmail}</strong>
          </p>
          <Form id="otp-verification-form" onSubmit={handleOtpFormSubmit}>
            <Form.Group>
              <Form.Label>Please enter the OTP</Form.Label>
              <Form.Control
                type="text"
                value={otp}
                className="otp-input"
                onChange={(e) => {
                  const val = e.target.value;
                  const onlyNums = val.replace(/[^\d]/g, "");
                  setOtp(onlyNums);
                  if (/\D/g.test(val)) {
                    setOtpError("Only numbers are allowed");
                  } else {
                    setOtpError("");
                  }
                }}
                onBlur={() => {
                  if (!otp.trim()) setOtpError("OTP is required");
                }}
                placeholder="Fill OTP received on email"
                maxLength={6}
              />
              {otpError && <p className="errorMessage">{otpError}</p>}
            </Form.Group>
          </Form>
          <p className="resend-otp-text">
            {"Didn't receive OTP?"}
            <button
              type="button"
              className="resend-otp-btn"
              onClick={handleResendOtp}
              disabled={!canResend}
            >
              {canResend ? "Resend OTP" : `Resend in ${resendCountdown}s`}
            </button>
          </p>
        </Modal.Body>
        <Modal.Footer className="otp-modal-footer">
          <Button form="otp-verification-form"
            type="submit"
            variant="update-cta"
            disabled={otp.length !== 6}
          >
            Verify
          </Button>
        </Modal.Footer>
      </Modal>
      <ToastContainer />
    </div>
  );
}
